<template>
  <a-form id="customElement-form" class="flex-grow-1 d-flex flex-column" :form="customElementForm" @submit="onSubmit">
    <div class="a-header">
      <span class="a-header--title slide-down-enter-active">Add Custom Element</span>
    </div>
    <div class="a-body flex-grow-1 p-20-px slide-up-enter-active">
      <a-row :gutter="24">
        <a-col :span="6">
          <a-form-item label="Element Name">
            <a-input
              v-decorator="[
                'element_name',
                {
                  rules: [
                    {
                      required: true,
                      message: 'Please input an element name!'
                    }
                  ]
                }
              ]"
              showSearch
              :filterOption="filterOption"
              size="large"
            >
            </a-input>
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item label="Description">
            <a-input
              v-decorator="[
                'description'
              ]"
              showSearch
              :filterOption="filterOption"
              size="large"
            >
            </a-input>
          </a-form-item>
        </a-col>
        <a-col :span="6">
          <a-form-item label="XPath">
            <a-input
              v-decorator="[
                'xpath',
                {
                  rules: [
                    {
                      required: true,
                      message: 'Please input XPath!'
                    }
                  ]
                }
              ]"
              size="large"
            >
            </a-input>
          </a-form-item>
        </a-col>
      </a-row>
    </div>
    <div class="a-footer">
      <a-button key="back" size="large" class="mr-3 slide-down-enter-active" @click="onCancel()">
        Cancel
      </a-button>
      <a-button key="submit" size="large" type="primary" html-type="submit" class="slide-down-enter-active">
        Save
      </a-button>
    </div>
  </a-form>
</template>

<script>
  // import { NOTIFICATION_TYPES, NOTIFICATION_TYPE_SMS } from '@constants/notifications';

  import CustomElementService from '../services/customElement.service';
  // import ContactGroupService from '@modules/ContactGroup/services/contact-group.service';

  export default {
    name: 'CustomElementForm',
    // props: {
    //   notification: {
    //     id: Number,
    //     contact_group_id: Number,
    //     url_id: Number,
    //     notification_type: String
    //   }
    // },
    data() {
      return {
        elementName: [],
        description: [],
        xpath: [],
        customElementForm: this.$form.createForm(this, {
          name: 'customElement-form'
        })        
      };
    },
    // computed: {
    //   isShowSMSNotification() {
    //     return Boolean(this.$store.state.user.data.rbac && this.$store.state.user.data.rbac.length > 0 && this.$store.state.user.data.rbac[0]);
    //   }
    // },
    // watch: {
    //   notification: function (newVal, oldVal) {
    //     if (newVal !== oldVal) {
    //       this.setNotificationForm();
    //     }
    //   }
    // },
    // beforeCreate() {
    //   this.customElementForm = this.$form.createForm(this, {
    //     name: 'customElement-form'
    //   });
    //   console.log("test")
    // },
    // mounted() {
    //   Promise.all([this.getContactGroupList(), this.getUrlList(), this.getNotificationTypes()]).then(() => {
    //     this.setNotificationForm();
    //   });
    // },
    methods: {
      onSubmit(e) {
        e.preventDefault();
        this.customElementForm.validateFields((err, values) => {
          if (!err) {
            this.$emit('submit', values);
            // console.log(values)
            // console.log(values.description)
          }
        });
      },
      onCancel() {
        this.$router.push('/custom-element/list');
      },
      // getNotificationTypes() {
      //   const $notificationType = new Promise((resolve) => {
      //     if (!this.isShowSMSNotification) {
      //       this.notificationTypes = NOTIFICATION_TYPES.filter((item) => {
      //         return item.id !== NOTIFICATION_TYPE_SMS;
      //       });
      //     } else {
      //       this.notificationTypes = NOTIFICATION_TYPES;
      //     }
      //     resolve(this.notificationTypes);
      //   });
      //   return $notificationType;
      // },
      // getContactGroupList() {
      //   return ContactGroupService.getList().then((data) => {
      //     this.contactGroups = data;
      //     return this.contactGroups;
      //   });
      // },
      // getUrlList() {
      //   return NotificationService.getUrlList().then((data) => {
      //     this.urls = data;
      //     return this.urls;
      //   });
      // },

      // setNotificationForm() {
      //   this.notificationForm.setFieldsValue({
      //     url_id: this.notification.url_id || this.urls[0].id,
      //     contact_group_id: this.notification.contact_group_id || this.contactGroups[0].id,
      //     notification_type: this.notification.notification_type || this.notificationTypes[0].id
      //   });
      // },
      // filterOption(input, option) {
      //   return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0;
      // }
    } 
  };
</script>

<style lang="scss" scoped></style>
